import React, { useState, useEffect } from "react";
import CryptoJS from "crypto-js";
import { jwtDecode } from "jwt-decode";
import { useNavigate } from "react-router-dom";

const Redirect = () => {
  const Navigate = useNavigate();
  const encryptedData = "s3cr3tK3y12345";
  const [token, setToken] = useState(
    sessionStorage.getItem("token") ? sessionStorage.getItem("token") : ""
  );
const [userDetails, setUserDetails] = useState();
  useEffect(() => {
    let key = window.location.href.split("=")[1];
    key = decodeURIComponent(key);

    const bytes = CryptoJS.AES.decrypt(key, encryptedData);
    const decryptedToken = bytes.toString(CryptoJS.enc.Utf8);
    setToken(decryptedToken);
    setUserDetails(jwtDecode(decryptedToken));

    sessionStorage.setItem("token", JSON.stringify(decryptedToken));
    sessionStorage.setItem("userDetails", JSON.stringify(jwtDecode(decryptedToken)));
  }, []);

    const role = userDetails?.role_id;    
    if (role == 6 || role == 8 || role == 10) {
      Navigate("/vendor-payment-creation-payable");
    } else if (role == 7 || role == 9 || role == 11) {
      Navigate("/vendor-payment-release");
    } else if(role==38){
      Navigate("/ledger-book");
    }else{
      Navigate("/ledger-book");
    }
};

export default Redirect;
